import React from 'react';
import styles from './Label.scss.js';

const Label = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: styles.wrapper
  }, text);
};
var Label$1 = Label;

export { Label$1 as default };
//# sourceMappingURL=Label.js.map
